// extracted by mini-css-extract-plugin
module.exports = {"curatedProduct":"ProductCardForUpsell_curatedProduct__s4121"};